import React, { Component } from 'react';
import getInitLocale from './getInitLocale';
import init from './init';

interface Props {
  locales: any;
  antLocal: any;
  onEvent?: any;
  removeEvent?: any;
  serverLang?: string;
  reloadAndLang?: any;
  defaultLocale?: string;
  ConfigProviderComponent: any;
  configProviderConfig: any;
}

interface State {
  initDone: boolean;
  antdLang: any;
  currentLocale: any;
}

function getsec(str:any) {
  if (!str) return 24 * 60 * 60 * 1000;
  const str1 = str.substring(1, str.length) * 1;
  const str2 = str.substring(0, 1);
  if (str2 === 's') {
    return str1 * 1000;
  }
  if (str2 === 'h') {
    return str1 * 60 * 60 * 1000;
  }
  if (str2 === 'd') {
    return str1 * 24 * 60 * 60 * 1000;
  }
  // 默认1天
  return 24 * 60 * 60 * 1000;
}

class Locale extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { defaultLocale } = props;
    this.state = {
      initDone: typeof window !== 'undefined' ? false : true,
      antdLang: typeof window !== 'undefined' ? props.antLocal[getInitLocale(defaultLocale)] : {}, // eslint-disable-line
      currentLocale: typeof window !== 'undefined' ? getInitLocale(defaultLocale) : 'zh-CN', // eslint-disable-line
    };

    if (typeof window === 'undefined') {
      init({
        currentLocale: props.serverLang, // 设置初始语音
        locales: props.locales,
      });
    }
  }

  reloadLocales = () => {
    if (typeof window !== 'undefined') {
      const strsec = getsec('d30');
      const exp:any = new Date();
      exp.setTime(exp.getTime() + strsec * 1);
      // 注意这里需要设置cookie的path，否则不同的cookie里面可能会有多个userLocale字段
      // document.cookie = `userLocale=${escape(lange)};expires=${exp.toGMTString()};path=/`;
    }
    this.loadLocales();
  };

  componentDidMount() {
    const { onEvent } = this.props;
    onEvent(() => this.reloadLocales()); // 监听语言改变事件

    // 获取初始化语言
    // const initLocal = getInitLocale();

    // const localLang = getCookie('userLocale');
    // if (!localLang) {
    //   setCookie('userLocale', initLocal, 'd30');
    // }
    this.loadLocales();
  }

  componentWillUnmount() {
    // 移除监听事件
    const { removeEvent } = this.props;
    removeEvent(() => this.reloadLocales());
  }

  loadLocales() {
    // const localLang = typeof window !== 'undefined' ? getInitLocale() : 'zh-CN'; // eslint-disable-line
    init({
      currentLocale: this.state.currentLocale, // 设置初始语言
      locales: this.props.locales,
    }).then(() => {
      this.setState({
        initDone: true,
      });
    });
  }

  render() {
    const { ConfigProviderComponent, antLocal, configProviderConfig } = this.props;
    const { initDone, currentLocale } = this.state;

    const configProvider = {
      locale: antLocal[currentLocale],
      ...configProviderConfig,
    }
  
    return initDone && <ConfigProviderComponent {...configProvider}>{this.props.children}</ConfigProviderComponent>;
  }
}

export default Locale;
